import {Component, Input} from '@angular/core';

@Component({
    selector: 'scitis-apply-to-machines-of-same-tag-warning',
    templateUrl: './apply-to-machines-of-same-tag-warning.component.html',
    styleUrls: ['./apply-to-machines-of-same-tag-warning.component.scss'],
    standalone: false
})
export class ApplyToMachinesOfSameTagWarningComponent {

  @Input()
  public applyToMachinesOfSameTag: boolean = false;
  @Input()
  public applyToMachinesOfSameTagMessage: string = '';

}
